const GOOGLE_MAPS_API_KEY = ""; // "AIzaSyBJwdwBwgQGcAdADjKOObvndzkZUOe0EJM";

export const mapOptions = {
  googleMapApiKey: GOOGLE_MAPS_API_KEY, // Make sure it's valid
  disableDefaultUI: true,               // Example option
  zoomControl: true,
};
